import type { ContextApi } from '@pancakeswap/localization'

export type AmountPart = { amount?: string | null; symbol?: string | null }

const isZero = (a: string) => !/[1-9]/.test(a)

/**
 * "Supplying 10,000,000,000 CADINU" / "Supplying 1 BNB and 2 CADINU" (Bez, 2026-10-02): only the non-zero amounts, joined with
 * "and" only when both are there. A side that is locked, empty or zero is left out instead of printing "Supplying and 10 CADINU".
 */
export function amountsSentence(t: ContextApi['t'], verb: 'Supplying' | 'Removing', parts: AmountPart[]): string {
  const shown = parts.filter((p): p is { amount: string; symbol: string } => Boolean(p.amount && p.symbol && !isZero(p.amount)))
  if (shown.length >= 2) {
    const [a, b] = shown
    return verb === 'Supplying'
      ? t('Supplying %amountA% %symbolA% and %amountB% %symbolB%', { amountA: a.amount, symbolA: a.symbol, amountB: b.amount, symbolB: b.symbol })
      : t('Removing %amountA% %symbolA% and %amountB% %symbolB%', { amountA: a.amount, symbolA: a.symbol, amountB: b.amount, symbolB: b.symbol })
  }
  if (shown.length === 1) {
    const [a] = shown
    return verb === 'Supplying' ? t('Supplying %amount% %symbol%', { amount: a.amount, symbol: a.symbol }) : t('Removing %amount% %symbol%', { amount: a.amount, symbol: a.symbol })
  }
  return verb === 'Supplying' ? t('Supplying') : t('Removing')
}
